export const DELIVERY_FLOW_STEP = {
  reservation: "reservation",
  coordonnees: "coordonnees",
  rdv: "rdv",
  recap: "recap",
} as const;

export type DeliveryFlowStep =
  (typeof DELIVERY_FLOW_STEP)[keyof typeof DELIVERY_FLOW_STEP];

export interface DeliveryFlowTab {
  id: DeliveryFlowStep;
  label: string;
  disabled: boolean;
}

interface GetDeliveryFlowTabsOptions {
  hasReservation: boolean;
  hasOrder?: boolean;
  isCoordonneesComplete: boolean;
}

export const getDeliveryFlowTabs = ({
  hasReservation,
  hasOrder = true,
  isCoordonneesComplete,
}: GetDeliveryFlowTabsOptions): DeliveryFlowTab[] => {
  const tabs: DeliveryFlowTab[] = [];

  if (hasReservation) {
    tabs.push({
      id: DELIVERY_FLOW_STEP.reservation,
      label: "Résa",
      disabled: false,
    });
  }

  if (!hasOrder) {
    return tabs;
  }

  tabs.push({
    id: DELIVERY_FLOW_STEP.coordonnees,
    label: "Coordonnées",
    disabled: false,
  });
  tabs.push({
    id: DELIVERY_FLOW_STEP.rdv,
    label: "RDV",
    disabled: !isCoordonneesComplete,
  });
  tabs.push({
    id: DELIVERY_FLOW_STEP.recap,
    label: "Récap",
    disabled: !isCoordonneesComplete,
  });

  return tabs;
};

export const getDefaultDeliveryFlowStep = (
  hasReservation: boolean,
  hasOrder = true,
): DeliveryFlowStep => {
  if (hasReservation) {
    return DELIVERY_FLOW_STEP.reservation;
  }

  if (hasOrder) {
    return DELIVERY_FLOW_STEP.coordonnees;
  }

  return DELIVERY_FLOW_STEP.reservation;
};

export const isDeliveryFlowStepAccessible = (
  step: DeliveryFlowStep,
  tabs: DeliveryFlowTab[],
) => {
  return tabs.some((tab) => tab.id === step && !tab.disabled);
};